import {
  ListItemText as MUIListItemText,
  ListItemTextProps,
} from '@mui/material';

export { type ListItemTextProps } from '@mui/material';

export function ListItemText(props: ListItemTextProps) {
  return <MUIListItemText {...props} />;
}
